var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.81684 21.9964L8.76775 21.9719L8.7145 21.9586C8.68804 21.952 8.66281 21.9372 8.63676 21.8949C8.60707 21.8466 8.5835 21.7703 8.5835 21.679V8.08604C8.5835 6.91793 9.46407 6.03735 10.6322 6.03735H17.4287C18.5968 6.03735 19.4774 6.91793 19.4774 8.08604V21.679C19.4774 21.7615 19.4582 21.8113 19.4339 21.8477C19.4075 21.8873 19.3546 21.9411 19.244 21.9964L19.1812 22.0278C19.165 22.0285 19.1491 22.0286 19.1278 22.0286C19.0587 22.0286 19.0235 22.0177 19.0017 22.008C18.9777 21.9973 18.9421 21.9756 18.8867 21.9202L14.384 17.4175L14.0304 17.064L13.6769 17.4175L9.1742 21.9202C9.04976 22.0446 8.93801 22.057 8.81684 21.9964Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteOutline);
export default __webpack_public_path__ + "static/media/White Outline.7a0e5296c3b92f92d5865f7ee2b24bb1.svg";
export { ForwardRef as ReactComponent };